import { Box, Grid, Tab, Tabs } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const options = [
  { route: "organization", label: "Organización" },
  { route: "suscriptions", label: "Suscripciones" },
  { route: "users", label: "Usuarios" },
  { route: "suborganizations", label: "Suborganizaciones" },
] as const;

interface Props {
  children: React.ReactNode;
  routeValue: (typeof options)[number]["route"];
}

const SelectTypeOfDashboard: FC<Props> = ({ children, routeValue }) => {
  const navigate = useNavigate();

  const { idOrganization } = useParams();

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    navigate(`/asistente/dashboard/${idOrganization}/${newValue}`);
  };

  return (
    <Grid container gap={4} sx={{ display: "flex", flexDirection: "column" }}>
      <Grid
        item
        sx={{
          backgroundColor: "rgba(51, 107, 135, 0.1)", // #336B87 con 10% transparencia
          borderRadius: "7px",
          padding: "6px 8px",
          width: "fit-content",
          fontFamily: "Montserrat",
        }}
      >
        <Tabs
          value={routeValue}
          onChange={handleChange}
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            minHeight: 0,
            "& .MuiTabs-flexContainer": {
              gap: 0.5,
            },
          }}
        >
          {options.map((option) => (
            <Tab
              key={option.route}
              label={option.label}
              value={option.route}
              sx={{
                textTransform: "none",
                fontFamily: "Montserrat",
                fontWeight: 700,
                minHeight: 40,
                fontSize: "16px",
                minWidth: "auto",
                padding: "8px 16px",
                borderRadius: "5px",
                backgroundColor:
                  routeValue === option.route ? "#336B87" : "transparent",
                color: "#336B87",
                "&.Mui-selected": {
                  color: "#fff", // fuerza blanco si está seleccionado
                },
                transition: "all 0.2s",
                "&:hover": {
                  backgroundColor:
                    routeValue === option.route
                      ? "#2c5f76"
                      : "rgba(0,0,0,0.05)",
                },
              }}
            />
          ))}
        </Tabs>
      </Grid>

      {/* Contenido debajo de las pestañas */}
      <Grid
        container
        gap={4}
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          color: "#005559",
        }}
      >
        {children}
      </Grid>
    </Grid>
  );
};

export default SelectTypeOfDashboard;
